import {
  Box,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Search } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import { SearchResult, useSearchBarStore } from "@roc/feature-app-core";
import { debounce } from "@roc/feature-utils";
import { observer } from "mobx-react";
import { useEffect, useMemo } from "react";

const useStyles = makeStyles((theme) =>
  createStyles({
    searchBar: {
      width: "100%",
      "& input, & svg path": {
        color: theme.palette.text.primary,
      },
      "& fieldset": {
        borderColor: theme.palette.divider,
      },
    },
    loanId: {
      fontWeight: "bold",
    },
    lenderName: {
      color: "#5f6368",
      fontSize: "12px",
    },
    dealName: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  })
);

export const AddAppraisalSearchBar = observer(({ store }) => {
  const classes = useStyles();
  const { searchBarStore } = useSearchBarStore();

  useEffect(() => {
    searchBarStore.reset();
  }, []);

  const search = useMemo(
    () =>
      debounce((value) => {
        if (value.length >= 3) {
          searchBarStore.searchLoans(value);
        } else {
          searchBarStore.reset();
        }
      }, 500),
    []
  );

  const onSelect = async (selectedOption: SearchResult) => {
    if (selectedOption?.loanId) {
      store.setLoan({
        loanId: selectedOption.loanId,
        dealName: selectedOption.dealName,
        lender: selectedOption.lender,
      });
    }
  };

  return (
    <Autocomplete
      className={classes.searchBar}
      size="small"
      options={searchBarStore.searchResults}
      renderInput={(options) => (
        <TextField
          {...options}
          autoFocus
          InputProps={{
            ...options.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <Search color="action" />
              </InputAdornment>
            ),
          }}
          placeholder="e.g. 12345"
          variant="outlined"
        />
      )}
      renderOption={(option) => <SearchOption option={option} />}
      blurOnSelect={true}
      getOptionLabel={(option) => option?.loanId?.toString() ?? ''}
      loading={searchBarStore.loading}
      filterOptions={(options) => options}
      autoSelect={false}
      onChange={(e, value) => {
        onSelect(value as SearchResult);
      }}
      onInputChange={(e, value) => search(value)}
    />
  );
});

const SearchOption = ({ option }) => {
  const classes = useStyles();
  return (
    <Box overflow="hidden" width="100%" py={0.5}>
      <Typography className={classes.dealName}>
        <span className={classes.loanId}>{option.loanId}</span> — {option.dealName}
      </Typography>
      <Typography className={classes.lenderName}>{option.lender}</Typography>
    </Box>
  );
};
